import API from './API.ts'

export default {
  //
  // GET
  //
  getRegister (workstationId) {
    return API.httpClient.get('register/find', {
      params: {
        workstation_id: workstationId
      }
    })
  },
  fetchRegisters () {
    return API.httpClient.get('register')
  },
  getReport ({ registerId, reportId }) {
    // Behöver inte registerId när hämtar Z-rapport
    return API.httpClient.get('register/report', {
      params: {
        register_id: registerId,
        report_id: reportId
      }
    })
  },
  getJournal (registerId) {
    return API.httpClient.get('register/journal', {
      params: {
        register_id: registerId
      }
    })
  },
  getRegReportsIndex ({ requestId, offset, visibleReports, sortedColumn, sortedDesc, filterRegisters }) {
    return API.httpClient.get('register/reg-reports', {
      params: {
        request_id: requestId,
        offset,
        visible_reports: visibleReports,
        sorted_column: sortedColumn,
        sorted_desc: sortedDesc,
        filter_registers: filterRegisters ?? []
      }
    })
  },

  //
  // POST
  //
  openRegister (registerId, balance) {
    return API.httpClient.post('register/open', {
      register_id: registerId,
      balance
    })
  },
  closeRegister (registerId) {
    return API.httpClient.post('register/close', {
      register_id: registerId
    })
  },
  assignRegister ({ registerId, workstationId }) {
    return API.httpClient.post('register/assign-register', {
      register_id: registerId,
      workstation_id: workstationId
    })
  },
  openCashDrawer (registerId) {
    return API.httpClient.post('register/opencashdrawer', {
      register_id: registerId
    })
  }
}
